import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {selectFleet, selectUser, State} from "../reducers";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class FleetAndUserService {

  private saveFleetUserUrl = '/api/fleet/fleetAndUser';

  private user;
  private fleet;

  constructor(protected httpClient:HttpClient,
              private store:Store<State>) { }

  saveFleetAndUser():Observable<any> {
    this.getUser();
    this.getFleet();

    let data = {
      user:this.user,
      fleet:this.fleet
    }
    return this.httpClient.post(this.saveFleetUserUrl,data);

  }

  getUser() {
    this.store.select(selectUser).pipe(take(1)).subscribe(
      val => this.user = val
    );
  }

  getFleet() {
    this.store.select(selectFleet).pipe(take(1)).subscribe(
      val => this.fleet = val
    );
  }

}
